import "../scss/_variables.scss";
import {createVuetify} from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import {aliases, fa} from 'vuetify/iconsets/fa';

const southWestFosterHub = {
    dark: false,
    colors: {
        primary: "#063345",
        primaryHighlight: "#0A4D68",
        border: "#E4E4E4",
        backgroundBlue: "#E3F3F5",
        backgroundGrey: "#E3E3E3",
        mainBlue: '#212121',
        cadet: "#5BA0AC",
        navy: "#063345",
        darkGrey: "#363A3D",
        lightGrey: "#696C6E",
        searchGrey: "#36464D",
        text: "#1B2B31",
        background: "#EDF2F8",
        secondary: "#256A67",
        secondaryshade: "#43908C",
        accent: "#82B1FF",
        error: "#B00020",
        info: "#2196F3",
        success: "#4CAF50",
        active: "#61B865",
        inactive: "#B00121",
        warning: "#fc8d05",
        warningHighlight: "#fff4e4",
        white: "#FFFFFF",
        apprenticeship: '#694523',
        certificateOfCompetence: '#4E6CC1',
        engineroom: '#DB2391',
        fireHealthAndSafety: '#ED0A0A',
        foodSafety: '#864BD1',
        introductionToCommercialFishing: '#143F80',
        medical: '#006F87',
        navigationAndRadio: '#837810',
        nvq: '#B3611D',
        seaSafety: '#4B7E0B',
        svq: '#138942',
        southWestFosterHubEvents: '#0C24FF',
        statusFirstContactReceived: '#30276A',
        statusKeepWarm: '#616A9B',
        statusInitialEnquiryArranged: '#5D4226',
        statusInitialEnquiryOngoing: '#5D4226',
        statusSentToLA: '#2C5DA6',
        statusInitialEnquiryCompleted: '#B94300',
        statusAtLAAccepted: '#005337',
        statusAtLARejected: '#7E2B2F',
        statusAtLATBC: '#6A7980',
        enquiryProgress: '#124D68',
        enquiryProgressDot: '#5A9FAB',
        btnHover: '#e7eef0',
        paginationActive: '#C2DBE0',
        emailTemplate: '#B4B5B6',
        selectedEmailTemplate: '#60a4ac',
        extra2: '#B000B4',
        extra3: '#873100',
        extra4: '#870000',
        extra5: '#008A1E',
        extra6: '#363A3D',
        extra7: '#143409',
        extra8: '#767676',
        extra9: '#0A0A0A',
    },
    variables: {
        'medium-emphasis-opacity': 1,
    },
};

const vuetify = createVuetify({
    components,
    directives,
    defaults: {
        VCheckbox: {
            color: 'primaryHighlight',
            'hideDetails': 'auto',
        },
        VBtn: {
            color: 'primary',
            rounded: "pill",
            style: [{
                textTransform: 'none',
                fontFamily: 'PT Sans, sans-serif',
                fontWeight: '700'
            }
            ],
        },
        VTextField: {
            'hideDetails': 'auto',
        },
        VRadioGroup: {
            'hideDetails': 'auto',
            'color': 'primaryHighlight',
        },
        VTab: {
            'color': 'text'
        },
        VTextarea: {
            'hideDetails': 'auto',
        },
        VSelect: {
            'hideDetails': 'auto',
        },
        VAutocomplete: {
            'hideDetails': 'auto',
        },
        VCombobox: {
            'hideDetails': 'auto'
        }
    },
    icons: {
        defaultSet: 'fa',
        aliases,
        sets: {
            fa,
        },
    },
    theme: {
        defaultTheme: "southWestFosterHub",
        themes: {
            southWestFosterHub,
        },
    },

});

export default vuetify;

